import PropTypes from 'prop-types';

export const favouritePassengerPropType = PropTypes.shape({
  email: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  surname: PropTypes.string.isRequired,
});

export const favouritePassengersPropType = PropTypes.arrayOf(
  favouritePassengerPropType,
);



// WEBPACK FOOTER //
// ./src/containers/FavouritePassengers/types.js